// Какой месяц календаря выбора дат стоит слева при открытии.
//
// Выбранный период должен быть виден сразу: до 30 дней — слева месяц его
// начала (короткий период через границу месяцев продолжается в правой
// половине); длиннее — слева месяц, где период заканчивается, чтобы конец
// выбора был на виду, а не прошлые 60 дней от сегодня (решение владельца
// 07.10.2026). Без выбранного периода — [прошлый месяц | текущий].
export const LONG_RANGE_DAYS = 30;

const DAY_MS = 86_400_000;

export function initialLeftMonth(from: Date | null, to: Date | null, today: Date = new Date()): Date {
  if (!from && !to) return new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const start = from ?? (to as Date);
  const end = to ?? start;
  const days = Math.round((end.getTime() - start.getTime()) / DAY_MS) + 1;
  const anchor = days > LONG_RANGE_DAYS ? end : start;
  return new Date(anchor.getFullYear(), anchor.getMonth(), 1);
}
